import { FAILURE_TYPES, FAILURE_NAMES } from '../../validationConstants';
import { ERROR_LOCALE_KEYS } from '../../../error/errorLocaleKeys';

export default (fieldValue, validationConfig) => {
    if (!fieldValue || !validationConfig.validValues) return;

    if (validationConfig.validValues.indexOf(fieldValue) !== -1) return;

    const validValues = validationConfig.validValues.join(',');

    const errorObject = {
        name: FAILURE_NAMES.select,
        type: FAILURE_TYPES.ERROR,
        debounced: true,
        message: `Not a valid ${validationConfig.name} value [${fieldValue}].  Valid values are [${validValues}]`,
        validValues,
        value: fieldValue,
        errorLocaleKey: ERROR_LOCALE_KEYS.VALIDATION.SELECT,
        context: { name: validationConfig.name },
    };

    return errorObject;
};
